import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import NumberConverter from "@my-dld/components/Form/Converters/NumberConverter";
import TextInputField from "@my-dld/components/Form/TextInputField";
import PickerInput from "@my-dld/components/Form/PickerInput";
import CurrencyInput from "@my-dld/components/Form/CurrencyInput";
import { Lookup } from "@eres/ejari-api/Entity";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { populateLookupOnTo, StateConsumer } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { RentalStatus } from "@eres/ejari-api/Entity/LeasedProperties";
import DateInputField from "@my-dld/components/Form/DateInputField";
import { toServerDate } from "@eres/core/dist/DateTime";
import { LeasedPropertySearch } from "@eres/ejari-api/IApi";
import { LeasedContext, updateLeasedContext } from "@eres/ejari-core/contexts/LeasedContext";

interface Props {
	onSearch: ( searchData: LeasedPropertySearch ) => void;
	onReset: () => void;
}

export interface LeasedProjectSearchState {
	ContractNumber?: string;
	DewaNumber?: string;
	DMNumber?: string;
	DMSubNumber?: string;
	Areas?: Lookup[];
	Area?: Lookup;
	PropertyType?: Lookup;
	PropertyStatus?: Lookup;
	BuildingName?: string;
	UnitNumber?: string;
	ContractStartDate?: Date;
	ContractEndDate?: Date;
	RentalAmountFrom?: string;
	RentalAmountTo?: string;
	error: { [ k: string ]: string };
	isExpand: boolean;
}

interface State extends LeasedProjectSearchState {

}

const PropertyTypes: Lookup[] = [
	{ Id: 0, ...LVStrings.all },
	{ Id: 2, ...LVStrings.unit },
	{ Id: 4, ...LVStrings.villa },
];

const PropertyStatus: Lookup[] = [
	{ Id: RentalStatus.ALL, ...LVStrings.all },
	{ Id: RentalStatus.VACANT, ...LVStrings.vacant },
	{ Id: RentalStatus.RENTED, ...LVStrings.rented },
];

class LeasedProjectSearch extends Component<Props, State> {
	static contextType = LeasedContext;
	context!: React.ContextType<typeof LeasedContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isExpand: false,
			error: {},
		};
	}

	componentDidMount() {
		const { searchState } = this.context;
		if ( searchState ) {
			this.setState( {
				...searchState,
			} );
		} else {
			populateLookupOnTo( EjariLookUp.AREAS, StateConsumer( this, "Areas" ) );
		}
	}

	render() {
		const { Areas, error, isExpand } = this.state;
		return <div className="mb-3">
			<div className="accordion accordian-style">
				<div className="card">
					<div className="card-header">
						<button
							className={ "btn btn-link btn-block text-start " + ( isExpand ? "" : "collapsed" ) }
							type="button" onClick={ this.onToggle }>{ Strings.search }</button>
					</div>
					<div className={ "collapse " + ( isExpand ? "show" : "hide" ) }>
						<div className="card-body">
							<div className="row">
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "ContractNumber" }
										holder={ this }
										label={ Strings.contract_number }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										type={ "text" }
										placeHolder={ Strings.contract_number }
										converter={ NumberConverter }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "DewaNumber" }
										holder={ this }
										label={ Strings.dewa }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										type={ "text" }
										placeHolder={ Strings.dewa }
										converter={ NumberConverter }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "DMNumber" }
										holder={ this }
										label={ Strings.municipality_number }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										type={ "text" }
										placeHolder={ Strings.municipality_number }
										converter={ NumberConverter }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "DMSubNumber" }
										holder={ this }
										label={ Strings.mun_sub_number }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										type={ "text" }
										placeHolder={ Strings.mun_sub_number }
										converter={ NumberConverter }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<PickerInput
										id={ "Area" }
										holder={ this }
										label={ Strings.area }
										containerClassName={ "form-group field-style select-control" }
										items={ Areas }
										toIdentifier={ IdExtractor }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<PickerInput
										id={ "PropertyType" }
										holder={ this }
										label={ Strings.property_type }
										containerClassName={ "form-group field-style select-control" }
										items={ PropertyTypes }
										toIdentifier={ IdExtractor }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<PickerInput
										id={ "PropertyStatus" }
										holder={ this }
										label={ Strings.property_status.replace( "<br/>", "" ) }
										containerClassName={ "form-group field-style select-control" }
										items={ PropertyStatus }
										toIdentifier={ IdExtractor }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "BuildingName" }
										holder={ this }
										label={ Strings.building_name }
										containerClassName={ "form-group" }
										placeHolder={ Strings.building_name }
										inputClassName={ "form-control" }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<TextInputField
										id={ "UnitNumber" }
										holder={ this }
										label={ Strings.Unit_Number_Label }
										containerClassName={ "form-group" }
										placeHolder={ Strings.Unit_Number_Label }
										inputClassName={ "form-control" }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<DateInputField
										id={ "ContractStartDate" }
										holder={ this }
										label={ Strings.contract_start_date }
										containerClassName={ "form-group position-relative" }
										extraOpts={ {
											maxDate: undefined,
										} }
										placeHolder={ Strings.contract_start_date }
										error={ error.ContractStartDate }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<DateInputField
										id={ "ContractEndDate" }
										holder={ this }
										label={ Strings.contract_end_date }
										containerClassName={ "form-group position-relative" }
										placeHolder={ Strings.contract_end_date }
										extraOpts={ {
											maxDate: undefined,
										} }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<CurrencyInput
										id={ "RentalAmountFrom" }
										holder={ this }
										label={ Strings.rental_amount_from }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										currencyType={ Strings.aed }
										placeHolder={ Strings.rental_amount_from }
										error={ error.RentalAmountFrom }/>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
									<CurrencyInput
										id={ "RentalAmountTo" }
										holder={ this }
										label={ Strings.rental_amount_to }
										containerClassName={ "form-group" }
										inputClassName={ "form-control" }
										placeHolder={ Strings.rental_amount_to }
										currencyType={ Strings.aed }/>
								</div>
								<div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12 form-group-flex">
									<div className="form-group">
										<button className="btn btn_1 btn_style1" onClick={ this.onSearch }>
											{ Strings.search }</button>
										<button
											className="btn btn-grey btn_style1 ms-2 me-2"
											onClick={ this.onReset }>
											{ Strings.reset }</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}

	private onSearch = () => {
		if ( this.isValid() ) {
			const {
				ContractNumber, DewaNumber, DMNumber, DMSubNumber, Area, PropertyType, PropertyStatus,
				BuildingName, UnitNumber, ContractStartDate, ContractEndDate, RentalAmountFrom, RentalAmountTo
			} = this.state;
			const propertySearch: LeasedPropertySearch = {
				ContractNumber: ContractNumber,
				DewaNumber: DewaNumber,
				DMNumber: DMNumber,
				DMSubNumber: DMSubNumber,
				Area: Area ? Area.Id : undefined,
				PropertyType: PropertyType ? PropertyType.Id : undefined,
				PropertyStatus: PropertyStatus ? PropertyStatus.Id : undefined,
				BuildingName: BuildingName,
				UnitNumber: UnitNumber,
				ContractStartDate: ContractStartDate ? toServerDate( ContractStartDate ) : undefined,
				ContractEndDate: ContractEndDate ? toServerDate( ContractEndDate ) : undefined,
				RentalAmountFrom: RentalAmountFrom,
				RentalAmountTo: RentalAmountTo,
			};
			updateLeasedContext( { searchState: this.state } );
			this.props.onSearch( propertySearch );
		}
	};

	private isValid() {
		let isValid = true;
		const { ContractStartDate, ContractEndDate, RentalAmountFrom, RentalAmountTo } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( ContractStartDate && ContractEndDate ) {
			if ( ContractStartDate > ContractEndDate ) {
				error.ContractStartDate = Strings.start_date_should_be_after_end_date;
				isValid = false;
			}
		}
		if ( !isEmptyStringOrNull( RentalAmountFrom ) && !isEmptyStringOrNull( RentalAmountTo ) ) {
			if ( parseFloat( RentalAmountFrom! ) > parseFloat( RentalAmountTo! ) ) {
				error.RentalAmountFrom = Strings.val_rental_amount_from_to;
				isValid = false;
			}
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	};

	private onReset = () => {
		this.setState( {
			ContractNumber: undefined,
			DewaNumber: undefined,
			DMNumber: undefined,
			DMSubNumber: undefined,
			Area: undefined,
			PropertyType: undefined,
			PropertyStatus: undefined,
			BuildingName: undefined,
			UnitNumber: undefined,
			ContractStartDate: undefined,
			ContractEndDate: undefined,
			RentalAmountFrom: undefined,
			RentalAmountTo: undefined,
			error: {},
			isExpand: this.state.isExpand,
		}, () => {
			updateLeasedContext( { searchState: this.state } );
			this.props.onReset();
		} );
	};

	private onToggle = () => {
		this.setState( { isExpand: !this.state.isExpand }, () => {
			updateLeasedContext( { searchState: this.state } );
		} );
	};
}

export default LeasedProjectSearch;
